import CryptoService from './services/CryptoService'
import CryptoUtilities from './services/CryptoUtilities'
import CryptoWorkerService from './services/CryptoWorkerService'
import EncryptionService from './services/EncryptionService'
import PasswordService from './services/PasswordService'

export const cryptoServiceInstance = CryptoService.getInstance()
export const encryptionServiceInstance = new EncryptionService()
export const passwordServiceInstance = new PasswordService()

export * from './services/WorkerService'
export {
  CryptoService,
  CryptoUtilities,
  CryptoWorkerService,
  EncryptionService,
  PasswordService,
}
